// extracted by mini-css-extract-plugin
export default {"section":"AccessWithoutConsentDialog_section__aFCiE","textbox":"AccessWithoutConsentDialog_textbox__cEqi0","label":"AccessWithoutConsentDialog_label__roWku"};